// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ico-cart[data-v-58fd015d]{color:#fff;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
